import React from "react";
import { IBreadcrumb } from "types";
import { ChevronRight } from "assets/icons";

interface BreadcrumbsProps {
  breadcrumbs: IBreadcrumb[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs }) => (
  <div className="breadcrumbs">
    <ol className="breadcrumbs__list">
      {breadcrumbs.map((breadcrumb) => (
        <li className="breadcrumbs__item" key={breadcrumb.url}>
          {breadcrumb.isMultiLink && breadcrumb.links ? (
            <>
              {breadcrumb.links?.map((item, index) => (
                <span>
                  {item.text}
                  {index < (breadcrumb.links?.length || 0) - 1 && ","}
                </span>
              ))}
            </>
          ) : (
            <span>{breadcrumb.text}</span>
          )}

          <span className="breadcrumbs__icon">
            <ChevronRight />
          </span>
        </li>
      ))}
    </ol>
  </div>
);
